import React from 'react';
import scoreRatingNoPassBg from '../../../../../../assets/sme/quiz/scoreRating_no_pass_bg.png';
import scoreRatingPassBg from '../../../../../../assets/student-training/quiz/scoreRating_pass_bg.png';

interface ScoreRatingProps {
  score?: number;
  word?: string;
  variant?: 'pass' | 'noPass';
  maxScore?: number;
  /** 组件大小（单位：rem，基于 750px 设计稿） */
  size?: number;
  startColor?: string;
  endColor?: string;
  textColor?: string;
  bgColor?: string;
}

const ScoreRating: React.FC<ScoreRatingProps> = ({
  score = 65,
  word = '',
  variant = 'pass',
  maxScore = 100,
  size = 27, // 设计稿 120px → 12rem（基于 750px 设计稿）
  startColor = '#77C2FF', // @civil-theme-color
  endColor = 'rgba(119,194,255,0.5)', // fade(@civil-theme-color, 50%)
  textColor = '#77C2FF', // @civil-theme-color
  bgColor = 'rgba(119,194,255,0.2)', // @civil-theme-color-02
}) => {
  void maxScore;
  void startColor;
  void endColor;
  void bgColor;

  const bg = variant === 'noPass' ? scoreRatingNoPassBg : scoreRatingPassBg;

  return (
    <div
      className="score-rating"
      style={{ width: `${size}rem`, aspectRatio: '432 / 243' }}
    >
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 432 243"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet"
      >
        <image
          href={bg}
          x="0"
          y="0"
          width="432"
          height="243"
          preserveAspectRatio="none"
        />

        {/* 分数文本：相对花环中心居中，适配 1～3 位分数 */}
        <text
          className="score-text"
          x="216"
          y="100"
          fontSize="96"
          fontWeight="bold"
          fill={textColor}
          textAnchor="middle"
          dominantBaseline="middle"
        >
          {score}
        </text>

        {/* 单位：紧挨分数右侧 */}
        <text
          className="score-unit"
          x={216 + String(score).length * 28}
          y="112"
          fontSize="32"
          fontWeight="500"
          fill={textColor}
          textAnchor="start"
          dominantBaseline="middle"
        >
          {word}
        </text>
      </svg>
    </div>
  );
};

export default ScoreRating;
